import React from 'react';
import SourceBadge from './source-badge';
import { MAKE_MODEL_ENTRY_SOURCE_BADGE } from '../constants';

// Legend mapping each colored source pill to its full source name.
// <Tag variant="Ready-Medium">Ready</Tag>
const SourceBadgeKey = () => (
  <div
    data-testid="source-badge-key"
    className="display-flex flex-wrap flex-align-center flex-justify-end margin-bottom-1"
  >
    {Object.values(MAKE_MODEL_ENTRY_SOURCE_BADGE).map((badge) => (
      <span
        key={badge.label}
        className="display-flex flex-align-center margin-left-2 margin-bottom-05"
      >
        <SourceBadge badge={badge} />
        <span className="font-sans-3xs margin-left-05">{badge.fullLabel}</span>
      </span>
    ))}
  </div>
);

export default SourceBadgeKey;
